module.exports = __webpack_public_path__ + "static/9286595_orig-ff1efe442a80f9497f3ee453fdf5f3e8.jpg";